import { FormEvent, useState } from "react";
import SpinnerLoader from "../../../../components/loader/spinner-loader";
import InputField from "../../../../components/form/input-field";
import { SuccessFlash } from "../../../../components/helper/flash-notification";
import { useApi } from "../../../../providers/ApiProvider";

type EditUserAccountType = {
  user?: any;
};

const EditUserAccount = ({ user }: EditUserAccountType) => {
  const api = useApi();
  const [showModal, setShowModal] = useState<boolean>(false);

  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<string | null>(null);

  const [phone_number, setPhoneNumber] = useState<string>("");
  const [phone_numberError, setPhoneNumberError] = useState<string | null>(
    null,
  );

  const submitForm = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email && !phone_number) {
      return;
    }

    const request = await api.POST({
      endpoint: `users/${user?.phone_number}/update`,
      payload: {
        email: email,
        phone_number: phone_number,
      },
      refreshKeys: ["users", user.phone_number],
    });

    if (!request) return;

    setEmail('');
    setPhoneNumber('');

    SuccessFlash("User account updated successfully.");

    setShowModal(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowModal(true)}
        className="flex items-center space-x-2 rounded-md text-primary border-primary hover:bg-opacity-90 input w-fit"
      >
        <span>Edit user</span>
      </button>
      {
        <div>
          <div
            className={`${showModal ? "flex" : "hidden"} overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full`}
          >
            <div className="relative w-full max-w-lg max-h-full p-4">
              <div className="relative bg-white rounded-lg shadow">
                <form onSubmit={submitForm} className="p-4 text-center md:p-5">
                  <h3 className="my-5 mb-5 text-lg font-normal text-tertiary">
                    Edit user:
                  </h3>
                  <div className="grid gap-4 mb-5 text-left">
                    <InputField
                      label="Email"
                      type="email"
                      onChangeInput={(e) => [
                        setEmail(e.target.value),
                        setEmailError(null),
                      ]}
                      error={emailError}
                      value={email}
                      placeholder={user?.email}
                    />
                    <InputField
                      label="Phone number"
                      type="number"
                      value={phone_number}
                      onChangeInput={(e) => [
                        setPhoneNumber(e.target.value),
                        setPhoneNumberError(null),
                      ]}
                      error={phone_numberError}
                      placeholder={user?.phone_number}
                    />
                  </div>
                  <button
                    disabled={api.postLoading}
                    type="submit"
                    className="text-white space-x-2 bg-primary hover:bg-tertiary focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
                  >
                    <span>Save changes</span>
                    {api.postLoading && <SpinnerLoader />}
                  </button>
                  <button
                    disabled={api.postLoading}
                    onClick={() => setShowModal(!showModal)}
                    type="button"
                    className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 "
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div
            className={`fixed inset-0 z-40 bg-gray-900/50 ${showModal ? "" : "hidden"}`}
          ></div>
        </div>
      }
    </div>
  );
};

export default EditUserAccount;
